import { cn } from "@roman/shared/utils";
import { useEffect, useState } from "react";

interface UseChartContainerProps {
  isLineVisible?: boolean;
  delay?: number;
  baseClassName?: string;
}

/**
 * ポインターイベントの有効/無効を管理するフック
 * ラインが表示される際に遅延をもってポインターイベントを有効化する
 */
export const useChartContainer = ({
  isLineVisible,
  delay = 500,
  baseClassName = "prediction-chart",
}: UseChartContainerProps) => {
  const [isPointerEventsEnabled, setIsPointerEventsEnabled] = useState(false);

  useEffect(() => {
    if (!isLineVisible) {
      setIsPointerEventsEnabled(false);
      return;
    }

    const timer = setTimeout(() => {
      setIsPointerEventsEnabled(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [isLineVisible, delay]);

  const className = cn(baseClassName, isPointerEventsEnabled ? "pointer-events-auto" : "pointer-events-none");

  return { className };
};
